export default {
  defaultProps: {
    margin: "dense",
  },
};
